import React, { useState } from 'react'
import { getImages } from '../const';

const ChatNewList = ({chatList, createChat, setNewChat}) => {
    const [searchTerm, setSearchTerm] = useState('');
    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
    };
  return (
    <>
        <div className="chatlist p-0">
            <div className="msg-head d-flex align-items-center justify-content-between d-md-none group-mob-header mb-3">
                <button className='white-back-arrow cursor-pointer d-md-none' onClick={() => {setNewChat(false);}}>
                    <img src={getImages('back-arrow.svg')} />
                </button>
                <div className='d-flex align-items-center w-100'>
                    <div className='chat-sm-title text-white fw-500 me-3'>New Chat</div>
                </div>
            </div>
            <div className="chat-header d-none d-md-block pb-0">
                <div className='d-flex align-items-center justify-content-between mb-4'>
                    <span className='ch-xs-title' onClick={() => {setNewChat(false);}}>
                        <span className='chat-back-arrow me-2'></span>New Chat
                    </span>
                    <div className='member-count'>3 of 10</div>
                </div>
                <div className="msg-search w-100">
                    <div className='position-relative search-input'>
                        <input type="text" className="form-control" placeholder="Search"
                            value={searchTerm}
                            onChange={handleSearchChange}
                        />
                        <span className="gray-search-icon"></span>
                    </div>
                </div>
            </div>
            <div className="modal-dialog-scrollable">
                <div className="modal-content">
                    <div className="modal-body p-0">
                        <div className="chat-lists">
                            <div className='ps-4 pt-5 pe-4'>
                                <div className='chat-ssm-title text-start mb-5'>New Chat List</div>
                            </div>
                            {<div className="chat-list chat-group-list">
                                {chatList.map((v, index) => (
                                    <div key={index}>
                                        <button type="button" className={`d-flex align-items-center w-100`} onClick={() => createChat({name:'Chat with ' + v.name,participants:[v]})}>
                                            <div className="flex-shrink-0">
                                                <span className='user-icon'></span>
                                            </div>
                                            <div className="flex-grow-1 ms-3">
                                                <h3>{v.name} <span className="status-circle green"></span></h3>
                                                <p>{}</p>
                                            </div>
                                        </button>
                                    </div>
                                ))}
                            </div> }
                            {/* <div className='ps-4 pt-5 pe-4'>
                                <div className='chat-ssm-title text-start mb-5'>You can select up to <span>10</span> participants</div>
                                <div className='custom-form chat-custom-form'>
                                    <div className='form-group mb-30'>
                                        <label>Group Name</label>
                                        <input type='text'
                                            className='form-control'
                                            value={groupName}
                                        onChange={(e)=>setGroupName(e.target.value)}
                                        onKeyPress={(e) => {if (e.key === 'Enter') {setGroupChatName()}}}
                                            placeholder='Enter group name' />
                                    </div>
                                    <button type="button" onClick={createGroupChat} className='red-btn w-100 ms-0 text-uppercase'>Create Group</button>
                                </div>
                            </div> */}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>
  )
}

export default ChatNewList